// src/components/BrandOne.js
import React from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import carousel images
import CarouselImg1 from '../../assets/images/brand/carousel-1.jpg';
import CarouselImg2 from '../../assets/images/brand/carousel-2.jpg';
import CarouselImg3 from '../../assets/images/brand/carousel-3.jpg';
import CarouselImg4 from '../../assets/images/brand/carousel-4.jpg';
import CarouselImg5 from '../../assets/images/brand/carousel-5.jpg';
import CarouselImg6 from '../../assets/images/brand/carousel-6.jpg';

// Swiper options
const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 3,
  spaceBetween: 30,
  speed: 2000,
  autoplay: {
    delay: 9000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next1',
    prevEl: '.swiper-button-prev1',
  },
  pagination: {
    el: '.swiper-dot-style1',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    375: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    575: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    768: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    992: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
    1320: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
  },
};

// Dynamic data array
const brandData = [
  { src: CarouselImg1, alt: 'Branded Caps and Hats' },
  { src: CarouselImg2, alt: 'Custom Branded Caps Collection' },
  { src: CarouselImg3, alt: 'Branded Water Bottles and Drinkware' },
  { src: CarouselImg4, alt: 'Professional Merchandise Display' },
  { src: CarouselImg5, alt: 'Custom Leather Keychains' },
  { src: CarouselImg6, alt: 'Premium Wooden Bottle Openers' },
];

export default function BrandOne() {
  return (
    <>
      {/* Brand One Start */}
      <section className="brand-one">
        <div className="container">
          {/* Swiper Slider */}
          <Swiper {...swiperOptions}>
            {brandData.map((brand, index) => (
              <SwiperSlide key={index}>
                <div className="brand-one__single">
                  <div className="brand-one__img">
                    <img src={brand.src} alt={brand.alt} />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {/* Brand One End */}
    </>
  );
}
